export const colXml = (state) => state.colContracts.colXML
export const isLoading = (state) => state.colContracts.colContract.isLoading
export const isSuccess = (state) => state.colContracts.colContract.isSuccess
export const colContracts = (state) => state.colContracts
export const colContract = (state) => state.colContracts.colContract.data
